/**
 * AboutVisual 스타일.
 * 원본 Emotion styled 컴포넌트를 Tailwind 클래스 문자열로 옮겼다.
 * image-set() 배경은 유틸리티로 표현할 수 없어 globals.css 의 클래스로 남겼다.
 */
/* isolate: AboutVisualWrap 의 mix-blend-mode 합성 그룹이 문서 루트까지 올라가는 것을 막는다 */
export const aboutVisualContainer =
  'isolate overflow-x-clip bg-apps-brandGrayBlack';

/* 배경(image-set + lg 이미지 교체)은 globals.css 의 .about-visual-bg 에 남겼다 */
export const aboutVisualWrap =
  'about-visual-bg px-[20px] py-[clamp(100px,10.417vw,200px)] text-center mix-blend-screen';

/*
 * 원본은 @media (max-width: 992px) 라 정확히 992px 에서도 적용된다.
 * Tailwind 의 max-lg 는 (width < 992px) 라 경계값이 달라지므로 미디어쿼리를 그대로 쓴다.
 * margin: 40px 0 의 좌우 0 은 reset 이 이미 0 으로 만들어 두어 my 만 붙인다.
 */
export const aboutVisualInner = '[@media(max-width:992px)]:my-[40px]';

/*
 * background: linear-gradient + background-clip: text 조합.
 * -webkit-background-clip / -webkit-text-fill-color 는 원본 선언을 그대로 옮긴다
 * (text-transparent 는 color 를 건드려 원본과 대상 속성이 다르다).
 */
export const aboutTitle = [
  'font-dmSans text-[clamp(66px,6.25vw,120px)] font-medium leading-[100%]',
  'bg-[linear-gradient(99deg,#bacdff_0%,#d49dff_47%,#ff3ec9_100%)]',
  'bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]',
  'pb-[4px] lg:pb-0 lg:leading-[120%]',
].join(' ');

/* lg 의 margin-top 은 기본값과 같은 24px 라 유틸리티를 중복으로 붙이지 않는다 */
export const aboutDesc =
  'mt-6 text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGrayWhite lg:text-[22px] lg:leading-[160%] lg:tracking-[-0.44px]';

export const aboutScrollWrap = 'relative h-[500vh]';

/* 원본의 .scroll-inner / video 자손 셀렉터는 해당 엘리먼트에 직접 붙인다 */
export const aboutScrollInner = 'scroll-inner sticky top-0 h-screen';

export const aboutScrollVideo = 'about-video h-full w-full object-cover';

/*
 * overflow-x: clip 은 overflow-y 를 auto 로 승격시키지 않는다.
 * (hidden 이면 불필요한 스크롤 컨테이너=합성 레이어가 생긴다)
 * 배경(image-set + lg 이미지 교체)은 globals.css 의 .about-image-list-bg 에 남겼다.
 */
export const imageListWrap =
  'about-image-list-bg relative overflow-x-clip py-[clamp(100px,10.417vw,200px)] text-[clamp(66px,6.25vw,120px)]';

export const imageListInner =
  'image-list-inner relative flex h-[clamp(340px,35.417vw,680px)] flex-col gap-[20px] lg:gap-[40px]';

export const imageInner = 'absolute flex gap-[16px] lg:gap-[24px]';

/* 원본의 &.img-toLeft / &.img-toRight 분기 */
export const imageInnerToLeft =
  'img-toLeft left-[clamp(117px,28.333vw,544px)] top-0';

export const imageInnerToRight =
  'img-toRight bottom-0 right-[clamp(117px,28.333vw,544px)]';

export const imageWrap =
  'relative aspect-[240/160] w-[clamp(240px,25vw,480px)] overflow-hidden rounded-[16px] lg:aspect-[480/320] lg:rounded-[20px]';
